<template>
    <a v-if="suggestion"
        :title="suggestion.url"
        class="c-search__suggestion"
        :class="{ '-selected': index == selectedIndex, 'c-search__suggestion--product-page' : isProductPage }"
        @click="executeAction(suggestion)"
        ref="element"
        :data-index="index"
        data-testid="auto-suggest-item"
		tabindex="0"
    >
        <figure class="c-search__image-wrapper" :class="isProductPage ? 'c-search__image-wrapper--product-page' : ''">
            <img class="c-search__image" :src="suggestion.imageUrl" :alt="suggestion.name" />
        </figure>
        <span class="c-search__label" v-if="suggestion.freeSampleLabel && !isProductPage">{{ suggestion.freeSampleLabel }}</span>
        <div class="c-search__info" :class="isProductPage ? 'c-search__info--product-page' : ''">
			<template v-if="suggestion.isCPManufacturer || !enableManufacturerTabs">
				<figure v-if="suggestion.displayManufactureIcon" class="c-search__manufacture-image">
					<img :alt="suggestion.manufacturerName" :src="suggestion.manufactureIconUrl" />
				</figure>
				<span v-if="suggestion.displayManufacturerName" class="c-search__manufacture-name">{{ suggestion.manufacturerName }}</span>
				<span v-if="suggestion.displayBrand" class="c-search__manufacture-name">{{ suggestion.brand }}</span>
			</template>
			<template v-else>
				<span class="c-search__manufacture-name">{{ suggestion.manufacturerName }}</span>
			</template>

            <span class="c-search__product-name">
                {{ suggestion.name }}
            </span>
            <div class="c-search__properties" v-if="hasProperties">
                <auto-suggest-item-property
                    v-for="(variantData, i) in suggestion.variantData" :key="variantData.label + '__' + i"
                    :label="variantData.label"
                    :values="variantData.dataValues"
                    :delimiter="variantData.delimiter"
                    :property-group-delimiter="propertyGroupDelimiter"
                    :is-last-group="i == suggestion.variantData.length - 1">
                </auto-suggest-item-property>
            </div>
        </div>
    </a>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import AutoSuggestItemProperty from 'shared/components/product/autoSuggestItemProperty.vue';
import { itemListIdAndName } from 'shared/settings/constants';
import { track_select_item } from 'shared/services/tracking/productTrackingService';

export default {
	name: 'auto-suggest-item',
	components: {
		AutoSuggestItemProperty,
	},
    props: {
        suggestion: {
            required: true,
            type: Object,
        },
        index: {
            required: true,
            type: Number,
        },
        selectedIndex: {
            required: true,
            type: Number,
        },
        propertyGroupDelimiter: {
            required: true,
            type: String,
        },
		actionLabel: {
			required: false,
			type: String,
		},
		isProductPage : {
        	required: false,
			type: Boolean,
			value: false,
		},
        ecommerceTrackingData: {
            default: {},
            type: Object,
        },
        registerWithObserver: {
			type: Function,
			required: true,
		},
		trackingEnabled: {
			type: Boolean,
			default: false,
		}
    },
    methods: {
        ...mapMutations([
            'setInteractionStarted',
            'setResults',
        ]),
        scrollIntoViewX() {
            this.$refs.element.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest'});
        },
		async executeAction(product) {
            if (this.actionLabel) {
                product.id = product.code;
				this.setResults([product]);
            }
            else {
                if (!this.interactionStarted) {
                    this.setInteractionStarted();
                }
                track_select_item(this.ecommerceTrackingData.value, this.suggestion, itemListIdAndName.AUTO_SUGGEST_SEARCH);

                window.location.assign(this.suggestion.url);
            }
        }

    },
    computed: {
        ...mapGetters({
			currency: 'getCurrency',
            interactionStarted: 'getInteractionStarted',
            productCategory: 'getProductCategory',
            visitorID: 'getVisitorID',
			enableManufacturerTabs: 'getEnableManufacturerTabs',
        }),
        hasProperties() {
            return this.suggestion.variantData && this.suggestion.variantData.length > 0;
        }
    },
	mounted() {
		if(this.trackingEnabled) {
			this.registerWithObserver(this.$el);
		}
	},
}
</script>
